module.exports = __webpack_public_path__ + "static/img/7_3.07bc37bc.jpg";